// extracted by mini-css-extract-plugin
export default {"not-found":"_404_not-found__Sl2B8","bold":"_404_bold__qrKNx"};